/**
 * Created by USER on 18/5/23.
 */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import {Button, message, Icon, Modal, Carousel} from 'antd';
import { translate } from 'react-i18next';
import {Link} from 'react-router-dom';
import {Tabs} from 'antd';
import {changeBarState} from '../redux/actions/headerbar_action';
import ImgList from '../images/img';
import httpClient from '../swagger/swagger';
import SingleSecurityAttacks from '../component/single_security_attacks';

const { client } = httpClient;
const {TabPane} = Tabs;

class ProductPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showImg: ImgList.img.productImg[0],
      jump: false,
      price: 0,
      originPrice: 0,
      comments: [],
      commentsModal: false,
      pics: [],
      picsNumber: 0,
      checkPicNumber: 0,
      securityAttacksData: [
        {time: '2014/02', img: ImgList.img.securitAttacks[2], content: this.props.t('security_attacks1'), arrow: 'left'},
        {time: '2015/01', img: ImgList.img.securitAttacks[4], content: this.props.t('security_attacks2'), arrow: 'right'},
        {time: '2016/08', img: ImgList.img.securitAttacks[0], content: this.props.t('security_attacks3'), arrow: 'left'},
        {time: '2017/07', img: ImgList.img.securitAttacks[5], content: this.props.t('security_attacks4'), arrow: 'right'},
        {time: '2017/12', img: ImgList.img.securitAttacks[1], content: this.props.t('security_attacks5'), arrow: 'left'},
        {time: '2018/01', img: ImgList.img.securitAttacks[6], content: this.props.t('security_attacks6'), arrow: 'right'},
        {time: '2018/02', img: ImgList.img.securitAttacks[3], content: this.props.t('security_attacks7'), arrow: 'left'},
        {time: '2018/06', img: ImgList.img.securitAttacks[7], content: this.props.t('security_attacks8'), arrow: 'right'},
        {time: '2018/07', img: ImgList.img.securitAttacks[8], content: this.props.t('security_attacks9'), arrow: 'left'}
      ]
    };
    this.scroll = this.scroll.bind(this)
  }

  componentWillMount() {
    this.props.dispatch(changeBarState('X1'));
    client.then((oclient) => { // 请求商品的详细信息
      oclient.apis.product.get_v1_product_id({
        id: 1
      }).then((res) => {
        if (res.obj.code !== 200) {
          message.error(res.obj.message);
        } else {
          this.setState({
            price: res.obj.data.price,
            originPrice: res.obj.data.originPrice
          });
        }
      }).catch(() => message.error(this.props.t('request_error')));
    }).catch(() => message.error(this.props.t('request_error')));
  }

  componentDidMount() {
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 500);
    this.getComments(); // 请求评论的数据
    window.addEventListener('scroll',  this.scroll)
  }

  scroll() {
    // 产品详情的tab切换
    const offsetTop = document.getElementsByClassName('ant-tabs')[0].offsetTop;
    const {offsetWidth} = document.body;
    const scrollTop = document.documentElement.scrollTop + document.body.scrollTop;
    const tabBar = document.getElementsByClassName('ant-tabs-bar')[0];
    const headerBar = document.getElementsByClassName('header-navigation_content')[0];
    const tab = document.getElementsByClassName('ant-tabs')[0];
    // 判断是否超过了tab区域 需不需要绝对定位
    if (scrollTop > (offsetTop - 84)) {
      headerBar.style.backgroundColor = '#FFF';
      tab.style.paddingTop = '30px';
      tabBar.setAttribute("style", `background-color: #FFF; position: fixed; 
        top: ${offsetWidth > 768 ? '84px' : '70px'}; width: 100%; z-index: 11`);
    } else {
      headerBar.style.backgroundColor = 'transparent';
      tab.style.paddingTop = '30px';
      tabBar.setAttribute("style", "background-color: transparent; position: unset; padding-top: 0;")
    }
  }

  tabOnchange() {
    // tab切换的时候是否需要滚动到顶部
    const offsetTop = document.getElementsByClassName('ant-tabs')[0].offsetTop;
    const scrollTop = document.documentElement.scrollTop + document.body.scrollTop;
    if (scrollTop > (offsetTop - 84)) {
      window.scroll(0, offsetTop - 82);
    }
  }

  getComments() { // 请求评论的数据
    client.then((oclient) => {
      oclient.apis.product.get_product_product_id_reviews({
        product_id: 1,
        page: 1,
        limit: 5
      }).then((res) => {
        if (res.obj.code !== 200) {
          message.error(res.obj.message);
        } else {
          this.setState({
            comments: res.obj.data
          });
        }
      }).catch(() => message.error(this.props.t('request_error')));
    }).catch(() => message.error(this.props.t('request_error')));
  }


  changeProductImg(showImg) { // 切换查看的产品详情图
    this.setState({
      showImg
    });
  }

  buyButton() { // 立即购买
    this.setState({
      jump: true
    });
  }

  returnIcon(rate) { // 包装的返回star的数量
    let a = Array.from(new Array(rate));
    return (
      <div>
        {
          a.map(() => (
            <i className="icon iconfont icon-xingji " />
          ))
        }
      </div>
    );
  }

  handleCancel() { // 隐藏评论modal
    this.setState({
      commentsModal: false
    })
  }

  amplificationImg(pics) { // 点击评论图片
    this.setState({
      commentsModal: true,
      pics,
      picsNumber: pics.length,
      checkPicNumber: 1
    });
  }
  prevImg() { // 评论图片的切换
    const {checkPicNumber} = this.state;
    this.setState({
      checkPicNumber: checkPicNumber - 1
    });
    this.refs.imgCarousel.prev()
  }

  nextImg() { // 评论图片的切换
    const {checkPicNumber} = this.state;
    this.setState({
      checkPicNumber: checkPicNumber + 1
    });
    this.refs.imgCarousel.next()
  }
  componentWillReceiveProps(nextProps){
    if (this.props.appBarReducer.language !== nextProps.appBarReducer.language) {
      this.setState({
        securityAttacksData: [
          {time: '2014/02', img: ImgList.img.securitAttacks[2], content: this.props.t('security_attacks1'), arrow: 'left'},
          {time: '2015/01', img: ImgList.img.securitAttacks[4], content: this.props.t('security_attacks2'), arrow: 'right'},
          {time: '2016/08', img: ImgList.img.securitAttacks[0], content: this.props.t('security_attacks3'), arrow: 'left'},
          {time: '2017/07', img: ImgList.img.securitAttacks[5], content: this.props.t('security_attacks4'), arrow: 'right'},
          {time: '2017/12', img: ImgList.img.securitAttacks[1], content: this.props.t('security_attacks5'), arrow: 'left'},
          {time: '2018/01', img: ImgList.img.securitAttacks[6], content: this.props.t('security_attacks6'), arrow: 'right'},
          {time: '2018/02', img: ImgList.img.securitAttacks[3], content: this.props.t('security_attacks7'), arrow: 'left'},
          {time: '2018/06', img: ImgList.img.securitAttacks[7], content: this.props.t('security_attacks8'), arrow: 'right'},
          {time: '2018/07', img: ImgList.img.securitAttacks[8], content: this.props.t('security_attacks9'), arrow: 'left'}
        ]
      })
    }
  }

  componentWillUnmount() {
    const headerBar = document.getElementsByClassName('header-navigation_content')[0];
    headerBar.style.backgroundColor = 'transparent';
    window.removeEventListener('scroll', this.scroll);
  }
  render() {
    const { t } = this.props;
    const {price, comments, commentsModal, pics,picsNumber,checkPicNumber, securityAttacksData, originPrice} = this.state;

    return (
      <div className="product">
        <div className="product_page">
          <div className="product_img">
            <div className="big_product_img">
              <img src={this.state.showImg} alt="LUBANSO" />
            </div>
            <div className="small_product_img">
              {
                ImgList.img.productImg.map((item, index) => (
                  <div
                    onMouseOver={() => this.changeProductImg(item)}
                    onFocus={() => this.changeProductImg(item)}
                    key={index}
                  >
                    <img src={item} alt="LUBANSO" />
                  </div>
                ))
              }
            </div>
          </div>
          <div className="buy_product">
            <div className="product_name">
              <img src={ImgList.img.lubansoType} alt="LUBANSO" />
              <span className="mobile_product_price">
              <span className="price_symbol">￥</span>
                {price}
                {
                  price === originPrice ? null :
                    <span className="original_price mobile_original_price">{originPrice}</span>
                }

              </span>
            </div>
            <p className="product_type">{t('lubanso_type')}</p>
            <ul className="product_features">
              <li>{t('theme_title_one')} LBTOS</li>
              <li>{t('theme_title_two')}</li>
              <li>{t('theme_title_three')}</li>
              <li>{t('lubanso_theme')}</li>
            </ul>
            <div>

            </div>
            <p className="web_product_price">
              <span className="price_symbol">￥</span>{price}
              {
                price === originPrice ? null : <span className="original_price">{originPrice}</span>
              }
            </p>
            <div>
              {/* <p className="payment_note payment_BTC_notice">{t('support_BTC')}</p> */}
              <Link
                onClick={(e) => {
                  if (this.state.jump) e.preventDefault();
                }}
                to="/product/productCart"
              >
                <Button className="buy_now_button" onClick={() => this.buyButton()}>
                  {t('apply_immediately')}
                </Button>
              </Link>
              {/* <div
                className="show_wechat_app"
              >
                <span className="show_wechat_app_name">{t('go_to_program')}</span>
                <Icon className="show_wechat_app_icon" type="right" />
                <div
                  className="show_wechat_app_details"
                >
                  <img src={ImgList.img.smallProgram} alt="LUBANSO" />
                </div>
              </div> */}
            </div>
          </div>
        </div>
        <Tabs
          defaultActiveKey={'product_details'}
          tabPosition="top"
          style={{ minHeight: 400 }}
          onChange={() => this.tabOnchange()}
        >
          <TabPane tab={t('product_tab_title1')} key="product_details">
            <div className="product_details_img product_details_img_first product_details_img_back_ground">
              <div>
                <h2><img src={ImgList.img.lubansoType} alt="LUBANSO"/></h2>
                <p>{t('theme_title_one')} LBTOS | {t('theme_title_two')}</p>
                <p>{t('theme_title_three')} | {t('lubanso_theme')}</p>
                <h3>{t('wallet_type')}</h3>
              </div>
              <img src={ImgList.img.productImgFirst} alt="lubanso" />
            </div>
            <div className="product_details_img product_details_img_advantages">
              <table>
                <tr>
                  <td>
                    <h2>{t('product_table_1x1')}</h2>
                    <p>{t('product_table_1x1_1')}</p>
                    <p>LBTOS</p>
                  </td>
                  <td>
                    <h2>{t('theme_title_two')}</h2>
                    <p>{t('product_table_1x2_1')}</p>
                    <p>{t('product_table_1x2_2')}</p>
                  </td>
                  <td>
                    <h2>{t('product_table_1x3')}</h2>
                    <p>{t('product_table_1x3_1')}</p>
                    <p>{t('product_table_1x3_2')}</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <h2>{t('product_table_2x1')}</h2>
                    <p>{t('product_table_2x1_1')}</p>
                    <p>{t('product_table_2x1_2')}</p>
                  </td>
                  <td>
                    <h2>{t('multi_currency')}</h2>
                    <p>{t('product_table_2x2_1')}</p>
                    <p>{t('product_table_2x2_2')}</p>
                  </td>
                  <td>
                    <h2>{t('product_table_2x3')}</h2>
                    <p>{t('product_table_2x3_1')}</p>
                    <p>{t('product_table_2x3_2')}</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <h2>{t('product_table_3x1')}</h2>
                    <p>{t('product_table_3x1_1')}</p>
                    <p>{t('product_table_3x1_2')}</p>
                  </td>
                  <td>
                    <h2>{t('product_table_3x2')}</h2>
                    <p>{t('product_table_3x2_1')}</p>
                    <p>{t('product_table_3x2_2')}</p>
                  </td>
                  <td>
                    <h2>{t('product_table_3x3')}</h2>
                    <p>{t('product_table_3x3_1')}</p>
                    <p>Mac OS</p>
                  </td>
                </tr>
              </table>
            </div>
            <div className="product_details_img product_details_img_chip">
              <div>
                <h2>{t('theme_title_two')}</h2>
                <h3>{t('product_details_chip1')}</h3>
                <h3>{t('product_details_chip2')}</h3>
                <h3>{t('product_details_chip3')}</h3>
              </div>
              <img src={ImgList.img.productImgChip} alt="lubanso" />
            </div>
            <div className="product_details_img product_details_img_system">
              <div>
                <h2>{t('theme_title_one')} LBTOS</h2>
                <h3>{t('theme_details_one1')}</h3>
                <h3>{t('theme_details_one2')}</h3>
                <h3>{t('theme_details_one3')}</h3>
              </div>
              <img src={ImgList.img.productImgSystem} alt="lubanso" />
            </div>
            <div className="product_details_img product_details_img_twoWay product_details_img_back_ground">
              <div>
                <h2>{t('product_table_1x3')}</h2>
                <h3>{t('theme_details_three1')}</h3>
                <h3>{t('theme_details_three2')}</h3>
              </div>
              <img src={ImgList.img.productImgTwoWay} alt="lubanso" />
            </div>
            <div className="product_details_img product_details_img_thin ">
              <div>
                <h2>{t('product_details_thin')}</h2>
                <h3>{t('product_details_thin1')}</h3>
              </div>
              <img src={ImgList.img.productImgThin} alt="lubanso" />
            </div>
            <div className="product_details_img product_details_img_hignEnd product_details_img_back_ground">
              <div>
                <h2>{t('product_details_hinEnd')}</h2>
                <h3>{t('product_details_hinEnd1')}</h3>
                <h3>{t('product_table_2x1_2')}</h3>
              </div>
              <img src={ImgList.img.productImgHignEnd} alt="lubanso" />
            </div>
            <div className="product_details_img product_details_img_App">
              <div>
                <h2>{t('web_app_advantage2')}</h2>
                <h3>{t('web_app_advantage3')}</h3>
              </div>
              <img src={ImgList.img.productImgApp} alt="lubanso" />
            </div>
            <div className="web_app_advantage">
              <div className="single_web_app_advantage">
                <div><i className="icon iconfont icon icon-gw-3"/></div>
                <span className="single_web_app_advantage_title">{t('web_app_advantage_friendly')}</span>
                <span className="single_web_app_advantage_notice">{t('web_app_advantage_friendly1')}</span>
                <span className="single_web_app_advantage_notice">{t('web_app_advantage_friendly2')}</span>
              </div>
              <div className="single_web_app_advantage">
                <div><i className="icon iconfont icon icon-gw-4"/></div>
                <span className="single_web_app_advantage_title">{t('web_app_advantage_efficient')}</span>
                <span className="single_web_app_advantage_notice">{t('web_app_advantage_efficient1')}</span>
                <span className="single_web_app_advantage_notice">{t('web_app_advantage_efficient2')}</span>
              </div>
              <div className="single_web_app_advantage">
                <div><i className="icon iconfont icon icon-gw-5"/></div>
                <span className="single_web_app_advantage_title">{t('web_app_advantage_platform')}</span>
                <span className="single_web_app_advantage_notice">{t('web_app_advantage_platform1')}</span>
                <span className="single_web_app_advantage_notice">Mac OS</span>
              </div>
            </div>
            <div className="product_details_img product_details_img_back_ground product_details_img_mobileApp">
              <div>
                <h2>{t('product_details_mobile_app')}</h2>
                <h3>{t('product_details_mobile_app1')}</h3>
              </div>
              <img src={ImgList.img.productImgFuture} alt="lubanso" />
            </div>
            <div className="multi_currency">
              <div>
                <div className="multi_currency_title">
                  {t('multi_currency')}
                </div>
                <div className="multi_currency__content_did multi_currency_content_did_coin">
                  <div>
                    <i className="icon iconfont icon-bizhong-4" />
                    <span>BTC</span>
                  </div>
                  {/* <div>
                    <i className="icon iconfont icon-bizhong-3" />
                    <span>BCH</span>
                  </div> */}
                  <div>
                    <i className="icon iconfont icon-bizhong-5" />
                    <span>EOS</span>
                  </div>
                  <div>
                    <i className="icon iconfont icon-bizhong-14" />
                    <span>USDT</span>
                  </div>
                  <div>
                    <i className="icon iconfont icon-bizhong-1" />
                    <span>LTC</span>
                  </div>
                  <div>
                    <i className="icon iconfont icon-bizhong-2" />
                    <span>BCD</span>
                  </div>
                  <div className="support_soon">
                    <i className="icon iconfont icon-bizhong-19" />
                    <span>{t('supportSoon')}</span>
                  </div>
                </div>
                <div className="multi_currency__content_did multi_currency_content_did_token">
                  <div>
                    <i className="icon iconfont icon-bizhong-" />
                    <span>ETH</span>
                  </div>
                  <div>
                    <i className="icon iconfont icon-bizhong-8" />
                    <span>BNB</span>
                  </div>
                  <div>
                    <i className="icon iconfont icon-bizhong-11" />
                    <span>ZRX</span>
                  </div>
                  <div>
                    <i className="icon iconfont icon-bizhong-7" />
                    <span>OMG</span>
                  </div>
                  <div>
                    <i className="icon iconfont icon-bizhong-6" />
                    <span>BAT</span>
                  </div>
                  <div>
                    <i className="icon iconfont icon-bizhong-18" />
                    <span>PAX</span>
                  </div>
                  <div>
                    <i className="icon iconfont icon-bizhong-13" />
                    <span>ZIL</span>
                  </div>
                  <div>
                    <i className="icon iconfont icon-bizhong-12" />
                    <span>AE</span>
                  </div>
                  <div>
                    <i className="icon iconfont icon-bizhong-10" />
                    <span>LINK</span>
                  </div>
                  <div>
                    <i className="icon iconfont icon-bizhong-16" />
                    <span>IOST</span>
                  </div>
                  <div>
                    <i className="icon iconfont icon-bizhong-17" />
                    <span>ELF</span>
                  </div>
                  <div className="multi_currency_more">
                    <i>...</i>
                    <span>{t('supportERC1')}</span>
                    <span>{t('supportERC2')}</span>
                  </div>
                </div>
                <div className="multi_currency__content_did multi_currency_content_did_token">
                  <div>
                    <i className="icon iconfont icon-bizhong-5" />
                    <span>EOS</span>
                  </div>
                  <div>
                    <i className="icon iconfont icon-NDX" />
                    <span>NDX</span>
                  </div>
                  <div>
                    <i className="icon iconfont icon-MEETONE" />
                    <span>MEETONE</span>
                  </div>
                  <div>
                    <i className="icon iconfont icon-WAL" />
                    <span>WAL</span>
                  </div>
                  <div>
                    <i className="icon iconfont icon-EOSDAC" />
                    <span>EOSDAC</span>
                  </div>
                  <div>
                    <i className="icon iconfont icon-IQ" />
                    <span>IQ</span>
                  </div>
                  <div>
                    <i className="icon iconfont icon-eBTC" />
                    <span>eBTC</span>
                  </div>
                  <div>
                    <i className="icon iconfont icon-eETH" />
                    <span>eETH</span>
                  </div>
                  <div className="multi_currency_more">
                    <i>...</i>
                    <span>{t('supportERC1')}</span>
                    <span>EOS Token</span>
                  </div>
                </div>
                {/* <div className="multi_currency_details">
                  <div>
                    <div className="multi_currency_details_icon">
                      <i className="icon iconfont icon-y-" />
                    </div>
                    <div className="multi_currency_details_coin">
                      <span>BTC ETH BCH EOS USDT LTC BCD ERC-20 EOS-Token</span>
                      <span> {t('multi_currency_did')}</span>
                    </div>
                  </div>
                  <div>
                    <div className="multi_currency_details_icon">
                      <i className="icon iconfont icon-y-1" />
                    </div>
                    <div className="multi_currency_details_coin">
                      <span>BSV &nbsp;</span>
                      <span>ADA</span>
                      <span> {t('multi_currency_now')}</span>
                    </div>
                  </div>
                  <div>
                    <div className="multi_currency_details_icon">
                      <i className="icon iconfont icon-y-2" />
                    </div>
                    <div className="multi_currency_details_coin">
                      <span>DASH ETC &nbsp;</span>
                      <span>XMR XLM</span>
                      <span> {t('multi_currency_will')}</span>
                    </div>
                  </div>
                </div> */}
                <div className="currency_banner" style={{background: `url(${ImgList.img.currencyBanner})`}}>
                  <div>
                    <div className="currency_banner_left">
                      <h2>{t('currency_banner_title')}</h2>
                      <p>{t('currency_banner_details')}</p>
                    </div>
                    <div className="currency_circle">
                      <div className="currency_circle1"></div>
                      <div className="currency_circle4"/>
                      <div className="currency_circle2">
                        <span />
                        <span />
                        <span />
                      </div>
                      <div className="currency_circle3">
                        {/* <span>USDT</span> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="product_details_img product_details_img_back_ground product_details_img_structure">
              <div>
                <div>
                  <span>{t('product_details_structure1')}</span>
                  <span>{t('product_details_structure2')}A</span>
                  <span>OLED</span>
                  <span>{t('product_details_structure2')}B</span>
                </div>
                <img src={ImgList.img.productImgStructure} alt="lubanso" />
              </div>
            </div>
            <div className="product_details_img product_details_img_type">
              <div>
                <h2>{t('product_details_information')}</h2>
                <ul className="product_details_img_type_details">
                  <li><p>{t('product_details_information1')}:</p> <p>LUBANSO</p></li>
                  <li><p>{t('product_details_information2')}:</p> <p>X1</p></li>
                  <li><p>{t('product_details_information3')}:</p> <p>{t('product_details_information4')}</p></li>
                  <li><p>{t('product_details_information5')}:</p> <p>0.96 {t('product_details_information6')}</p></li>
                  <li><p>{t('product_details_information7')}:</p> <p>MicroUSB</p></li>
                  <li><p>{t('product_details_information8')}:</p> <p>62*28*7mm</p></li>
                  <li><p>{t('product_details_information9')}:</p> <p>Windows, Mac OS</p></li>
                  <li><p>{t('product_details_information10')}:</p> <p>OLED</p></li>
                  <li><p>{t('product_details_information11')}:</p> <p>{t('product_details_information13')}</p></li>
                  <li><p>{t('product_details_information12')}:</p> <p>BIP44、BIP49、BIP84、BIP39</p></li>
                </ul>
              </div>
              <img src={ImgList.img.productImgParameter} alt="lubanso" />
            </div>
            <div className="product_details_img product_details_img_laboratory">
              <div className="product_details_laboratory_first_line">
                <div>
                  <div className="product_laboratory_title">
                    <p>LUBANSO</p>
                    <p>{t('product_details_laboratory')}</p>
                  </div>
                  <div className="product_laboratory_details">
                <span>
                  {t('product_details_laboratory_details1')} |
                  &nbsp;{t('product_details_laboratory_details2')} |
                  &nbsp;{t('product_details_laboratory_details3')} |
                  &nbsp;{t('product_details_laboratory_details4')} |
                  &nbsp;{t('product_details_laboratory_details5')}
                  </span>
                  </div>
                  <img src={ImgList.img.laboratory1} alt="lubanso" />
                </div>
                <div>
                  <img src={ImgList.img.laboratory2} alt="lubanso" />
                  <img src={ImgList.img.laboratory3} alt="lubanso" />
                </div>
                <div>
                  <img src={ImgList.img.laboratory5} alt="lubanso" />
                </div>
              </div>
              <div className="product_details_laboratory_second_line">
                <div>
                  <img src={ImgList.img.laboratory6} alt="lubanso" />
                </div>
                <div>
                  <img src={ImgList.img.laboratory7} alt="lubanso" />
                </div>
                <div>
                  <img src={ImgList.img.laboratory8} alt="lubanso" />
                </div>
                <div>
                  <img src={ImgList.img.laboratory4} alt="lubanso" />
                </div>
              </div>
            </div>
            <div className="product_details_quick_learn">
              <h3 className="product_details_quick_learn_title">{t('quick_guide')}</h3>
              <div className="product_details_quick_learn_detail">
                <div>
                  <img src={ImgList.img.productDetailsQuickLearn2} alt="lubanso" />
                  <p>{t('quick_guide_step1')}</p>
                  <div>{t('quick_guide_step1_details')}</div>
                </div>
                <div>
                  <img src={ImgList.img.productDetailsQuickLearn1} alt="lubanso" />
                  <p>{t('quick_guide_step2')}</p>
                  <div>{t('quick_guide_step2_details')}</div>
                </div>
                <div>
                  <img src={ImgList.img.productDetailsQuickLearn} alt="lubanso" />
                  <p>{t('quick_guide_step3')}</p>
                  <div>{t('quick_guide_step3_details')}</div>
                </div>
              </div>
            </div>
            <div className="product_details_security_attacks">
              <i />
              <i />
              <div>
                <h3>{t('security_attacks')}</h3>
                <ul>
                  {
                    securityAttacksData.map(item => (
                      <SingleSecurityAttacks
                        key={item.time}
                        item={item}
                      />
                    ))
                  }
                </ul>
                <div className="security_attacks_after">...</div>
              </div>
            </div>
            <div className="product_details_our_advantages">
              <div>
                <h3> {t('our_advantages')}</h3>
                <ul>
                  <li>
                    <span className="product_details_our_advantages_icon" />
                    <span>
                      {t('our_advantages1')}
                    </span>
                  </li>
                  <li>
                    <span className="product_details_our_advantages_icon" />
                    <span>
                       {t('our_advantages2')}
                    </span>
                  </li>
                  <li>
                    <span className="product_details_our_advantages_icon" />
                    <span>
                      {t('our_advantages3')}
                    </span>
                  </li>
                </ul>
              </div>
            </div>
            <div className="product_details_img product_details_activity">
              <div>{t('activity')}</div>
              <img src={ImgList.img.activityPhoto} alt="lubanso" />
            </div>
            <div className="product_details_user product_details_img_back_ground">
              <h3>{t('product_details_user')}</h3>
              <div>
                <div><img src={ImgList.img.productUser[0]} alt="lubanso"/> </div>
                <div><img src={ImgList.img.productUser[1]} alt="lubanso"/> </div>
                <div><img src={ImgList.img.productUser[2]} alt="lubanso"/> </div>
                <div><img src={ImgList.img.productUser[3]} alt="lubanso"/> </div>
                <div><img src={ImgList.img.productUser[4]} alt="lubanso"/> </div>
              </div>
            </div>
            <div className="product_details_map">
              <div>
                <div className="product_details_map_head">
                  <span>{t('product_details_map')}</span>
                  <i/>
                </div>
                <img src={ImgList.img.productDetailsMap} alt="lubanso" />
                <div className="product_details_map_notice">
                  <span>{t('product_details_map_notice')}</span>
                  <span>+</span>
                </div>
              </div>
            </div>
            <div className="product_details_img product_details_img_back_ground product_details_img_packaging">
              <img src={ImgList.img.productPackaging} alt="lubanso" />
              <div>
                <ul>
                  <li>{t('product_details_packaging1')}</li>
                  <li>X1</li>
                  <li>{t('product_details_structure1')}</li>
                  <li>{t('product_details_packaging2')}</li>
                  <li>{t('product_details_packaging3')}</li>
                  <li>{t('product_details_packaging4')}</li>
                </ul>
              </div>
            </div>
          </TabPane>
          <TabPane tab={t('product_tab_title2')} key="product_specs">
            <div className="product_specs_title">LUBANSO X1</div>
            <ul className="product_specs">
              <li>
                <div>{t('appearance')}</div>
                <div className="product_specs_view">
                  <img src={ImgList.img.productDetailsViewColor} alt="lubanso"/>
                  <div><i className="product_specs_view_color" />{t('appearance_color')}</div>
                </div>
              </li>
              <li>
                <div>{t('specification')}</div>
                <div className="product_specs_hardware">
                  <ul>
                    <li><span>{t('specification1')}</span></li>
                    <li><span>{t('specification2')}</span></li>
                    <li><span>{t('specification3')}</span></li>
                    <li><span>{t('specification4')}</span></li>
                    <li><span>{t('specification5')}</span></li>
                    <li><span>{t('specification6')}</span></li>
                    <li><span>{t('specification7')}</span></li>
                    <li><span>{t('specification8')}</span></li>
                    <li><span>{t('specification9')}</span></li>
                  </ul>
                  <ul>
                    <li><span>LUBANSO</span></li>
                    <li><span>X1</span></li>
                    <li><span>Micro USB</span></li>
                    <li><span>5V/500mA</span></li>
                    <li><span>1m</span></li>
                    <li><span>Window, Mac OS</span></li>
                    <li><span>{t('specification11')}</span></li>
                    <li><span>BIP44, BIP49, BIP84, BIP39</span></li>
                    <li><span>{t('specification10')}</span></li>
                  </ul>
                </div>
              </li>
              <li>
                <div>{t('specification_currency')}</div>
                <div>{t('specification_currency_details')}</div>
              </li>
              <li>
                <div>{t('specification_Dimension')}</div>
                <div className="product_specs_size">
                  <div>
                    <ul>
                      <li><span>{t('specification_Dimension1')}</span></li>
                      <li><span>{t('specification_Dimension2')}</span></li>
                      <li><span>{t('specification_Dimension3')}</span></li>
                      <li><span>{t('specification_Dimension4')}</span></li>
                    </ul>
                    <ul>
                      <li><span>{t('specification_Dimension5')}62mm</span></li>
                      <li><span>{t('specification_Dimension5')}28mm</span></li>
                      <li><span>{t('specification_Dimension5')}7mm</span></li>
                      <li><span>{t('specification_Dimension5')}36g</span></li>
                    </ul>
                  </div>

                  <img src={ImgList.img.productSpecsSize} alt="lubanso"/>
                </div>
              </li>
              <li>
                <div>{t('specification_screen')}</div>
                <div className="product_specs_screen">
                  <div>
                    <ul>
                      <li><span>{t('specification_screen1')}</span></li>
                      <li><span>{t('specification_screen2')}</span></li>
                      <li><span>{t('specification_screen3')}</span></li>
                    </ul>
                    <ul>
                      <li><span>{t('specification_screen4')}</span></li>
                      <li><span>OLED</span></li>
                      <li><span>128*64</span></li>
                    </ul>
                  </div>
                  <img src={ImgList.img.productSpecsScreen} alt="lubanso"/>
                </div>
              </li>
              <li>
                <div>{t('specification_pack')}</div>
                <div className="product_specs_pack">
                  <div>
                    <ul>
                      <li><span>{t('specification_pack1')}</span></li>
                      <li><span>{t('specification_pack2')}</span></li>
                      <li><span>{t('specification_pack3')}</span></li>
                      <li><span>{t('specification_pack4')}</span></li>
                      <li><span>{t('specification_pack5')}</span></li>
                    </ul>
                    <ul>
                      <li><span>x1</span></li>
                      <li><span>x1</span></li>
                      <li><span>x1</span></li>
                      <li><span>x1</span></li>
                      <li><span>x3</span></li>
                    </ul>
                  </div>
                </div>
              </li>
              <li>
                <div>{t('specification_after_sale')}</div>
                <div className="product_specs_after_sale">
                  <div>
                    {t('specification_after_sale1')}
                    <span>{t('specification_after_sale2')}</span>
                    {t('specification_after_sale3')}
                  </div>
                  <div>{t('specification_after_sale4')} 18072775716</div>
                  <div>{t('specification_after_sale5')} www.lubanso.com</div>
                </div>
              </li>
            </ul>
          </TabPane>
        </Tabs>
        {/* <div className="user_comments">
          <div>
            <div className="user_comments_head">
              <div className="user_comments_head_title">
                <div>
                  <span>98</span>
                  <span>％</span>
                </div>
                <div>{t('user_comments_percent')}</div>
              </div>
              <div className="user_comments_head_content">
                <p>{t('user_comments_impression')}</p>
                <div>
                  <span>{t('user_comments_impression1')}</span>
                  <span>{t('user_comments_impression2')}</span>
                  <span>{t('user_comments_impression3')}</span>
                  <span>{t('user_comments_impression4')}</span>
                </div>
              </div>
            </div>
            <div className="all_comments">
              {
                comments.map((item) => (
                  <div className="single_user_comments" key={item.uid}>
                    <div className="single_comments_user_information">
                      <span className="icon iconfont icon-lubanso" />
                      <div>
                        <span>{item.nick_name}</span>
                        <span className="single_comments_web_star">
                           {
                             this.returnIcon(item.rate)
                           }
                        </span>
                        <div className="single_comments_mobile_time">{item.date_created}</div>
                      </div>
                      <div className="single_comments_mobile_star">
                        {
                         this.returnIcon(item.rate)
                        }
                      </div>
                    </div>
                    <div className="single_comments_user_content">
                      <div>{item.text}</div>
                      <div>
                        {
                          item.pics.map((itemImg, index) => (
                            <img key={index} src={`${itemImg}?x-oss-process=style/thumbnail`} alt="lubanso"  onClick={() => this.amplificationImg(item.pics, index)}/>
                          ))
                        }
                      </div>
                    </div>
                    <div className="single_comments_user_content_time">
                      {item.date_created}
                    </div>
                  </div>
                ))
              }
            </div>
          </div>
        </div> */}
        <Modal
          visible={commentsModal}
          footer={null}
          onCancel={() => this.handleCancel()}
          destroyOnClose={true}
          width={700}
        >
          <div className="amplification_area">
            <div className="amplification_img">
              <div
                className="amplification_img_switch_left"
                onClick={() => this.prevImg()}
                style={{display: checkPicNumber === 1 ? 'none' : 'block'}}
              >
                <i className="icon iconfont icon-ArtboardCopy1" />
              </div>
              <Carousel
                dots={false}
                ref="imgCarousel"
              >
                {
                  pics.map((itemImg, index) => (
                    <img key={index} src={`${itemImg}?x-oss-process=style/not_rotation`} alt="lubanso" />
                  ))
                }
              </Carousel>
              <div
                className="amplification_img_switch_right"
                onClick={() => this.nextImg()}
                style={{display: checkPicNumber === pics.length ? 'none' : 'block'}}
              >
                <i className="icon iconfont icon-ArtboardCopy" />
              </div>
            </div>
            <div className="amplification_img_page">
              <span>{checkPicNumber}/{picsNumber}</span>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}


function select(state) {
  return {
    appBarReducer: state.appBarReducer
  };
}

const ProductPageTranslate = translate('translations')(ProductPage);

export default connect(select)(ProductPageTranslate);

